// @flow

import React, { type Node } from 'react';
import { TipsBox } from '@tectonics/look-and-feel/shopify/commons/organisms/tips-box';

import tipSmartphoneAppSrc from './icons/tip-smartphone-app.svg';
import tipCalendar3DaysSrc from './icons/tip-calendar-3-days.svg';
import tipDuplicateSrc from './icons/tip-duplicate.svg';

export function DisplayEfectyInstructions(): Node {
  return (
    <TipsBox title="Instrucciones de pago" tipsModel={[
      {
        imgSrc: tipSmartphoneAppSrc,
        altText: 'smartphone confirmation icon',
        tipText: `
          Indica al cajero de punto Efecty de tu preferencia
          que el pago de este recibo esta dirigido a EBANX y
          dicta el número de pago para que la operación sea realizada
          con éxito.
        `,
      },
      {
        imgSrc: tipCalendar3DaysSrc,
        altText: 'calendar icon',
        tipText: `
          La confirmación del pago puede llevar aproximadamente
          3 días hábiles para verse reflejado en el sitio web de la
          compra.
        `,
      },
      {
        imgSrc: tipDuplicateSrc,
        altText: 'do not pay duplicate icon',
        tipText: `
          Esta boleta es válida solamente para un código de pedido,
          no debe realizar un pago doble o uno de ellos será cancelado.
        `,
      },
    ]} />
  );
}
